// EnvBanner — persistent banner shown while the console is pointed at
// production.
//
// This replaces a safety property the unified console removes: with two
// domains, the URL told you whether purgeUser (irreversible) would hit
// real users. With one origin it cannot.
//
// The banner keys off the environment the BACKEND reports
// (admin/flags.ts discoveryConfig), never the client's localStorage
// belief. If the client thinks dev and the server says prod, the server
// wins and the banner shows. A client-side toggle must never be the
// thing that decides whether you are looking at production.
//
// discoveryConfig (not listFlags) is the query that exposes
// environment/allowPurge — it's also what UserActionsMenu.tsx calls for
// the same purpose, so this reuses it rather than adding a second query.
import { useQuery } from 'convex/react';
import { api } from '../../../convex/functions/_generated/api';
import { adminSession } from '@/lib/api';

export function EnvBanner() {
  const token = adminSession.getToken();
  const flags = useQuery(
    api.admin.flags.discoveryConfig,
    token ? { token } : 'skip',
  );

  // Until the server answers we do not know. Say nothing rather than
  // claim "dev" — a false all-clear is worse than no banner.
  if (!flags) return null;
  if (flags.environment !== 'prod') return null;

  return (
    <div
      role="alert"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: '#B00020',
        color: '#fff',
        padding: '8px 16px',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        fontSize: 12,
        textAlign: 'center',
      }}
    >
      Production — changes affect real users
    </div>
  );
}
